export default __webpack_public_path__ + "two-columns-layout.png";